import React from 'react'
import moment from 'moment'
import { UncontrolledTooltip } from 'reactstrap'
import { PreferredDateTimeContext } from '../Context/PreferredDateTimeContext'
import './DatetimeRenderer.css'
import { graphql } from '@apollo/client/react/hoc'
import { GetConfigurationSettings } from "../Functions/querys"

class DatetimeRenderer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            systemTimezone: moment.tz.guess(),
            popoverId: `popover-${Math.random().toString(36).substr(2, 9)}`,
            placement: this.props.placement ? this.props.placement : "bottom"
        }
    }

    isDateString(datetime) {
        // Regular expression to match the ISO 8601 date format
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/
        if (dateRegex.test(datetime))
            return true

        return false
    }

    render() {
        return (

            <PreferredDateTimeContext.Consumer>
                {({ preferredDateTimeInfo }) => {
                    const preferredTimezone = this.props.customerTimezone || preferredDateTimeInfo.timezone

                    return (
                        <span className="datetime-renderer">
                            <span id={this.state.popoverId}>
                                {/* `label` lets a caller show something else in place of the
                                    formatted stamp -- "2 minutes ago", say -- while keeping the
                                    time-conversion tooltip. Omit it for the usual behaviour. */}
                                {this.props.label !== undefined && this.props.label !== null ? (
                                    this.props.label
                                ) : this.isDateString(this.props.datetime) ? (
                                    moment(this.props.datetime).format(preferredDateTimeInfo.dateFormat)
                                ) : (
                                    moment(this.props.datetime)
                                        .tz(preferredTimezone)
                                        .format(`${preferredDateTimeInfo.dateFormat} ${preferredDateTimeInfo.timeFormat}`)
                                )}
                            </span>

                            {!this.props.hideTooltip && !this.isDateString(this.props.datetime) && (
                                <UncontrolledTooltip
                                    id="datetime-conversion-tooltip"
                                    target={this.state.popoverId}
                                    placement={this.state.placement}
                                >
                                    <table>
                                        <thead>
                                            <tr>
                                                <th colSpan="3">
                                                    Time conversion
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.customerTimezone ? (
                                                <>
                                                    <tr>
                                                        <td>{moment.tz(this.props.customerTimezone).format('z')} &#x2022; Customer</td>
                                                        <td>{moment(this.props.datetime).tz(this.props.customerTimezone).format("LT")}</td>
                                                        <td>{moment(this.props.datetime).tz(this.props.customerTimezone).format("ll")}</td>
                                                    </tr>
                                                    {this.props.customerTimezone !== preferredDateTimeInfo.timezone && (
                                                        <tr>
                                                            <td>{moment.tz(preferredDateTimeInfo.timezone).format('z')} &#x2022; Your account</td>
                                                            <td>{moment(this.props.datetime).tz(preferredDateTimeInfo.timezone).format("LT")}</td>
                                                            <td>{moment(this.props.datetime).tz(preferredDateTimeInfo.timezone).format("ll")}</td>
                                                        </tr>
                                                    )}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td>{moment.tz(preferredDateTimeInfo.timezone).format('z')} &#x2022; Your account</td>
                                                    <td>{moment(this.props.datetime).tz(preferredDateTimeInfo.timezone).format("LT")}</td>
                                                    <td>{moment(this.props.datetime).tz(preferredDateTimeInfo.timezone).format("ll")}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>UTC</td>
                                                <td>{moment(this.props.datetime).utc().format("LT")}</td>
                                                <td>{moment(this.props.datetime).utc().format("ll")}</td>
                                            </tr>
                                            {this.state.systemTimezone !== preferredDateTimeInfo.timezone && (
                                                <tr>
                                                    <td>{moment.tz(this.state.systemTimezone).format('z')} &#x2022; Your computer</td>
                                                    <td>{moment(this.props.datetime).tz(this.state.systemTimezone).format("LT")}</td>
                                                    <td>{moment(this.props.datetime).tz(this.state.systemTimezone).format("ll")}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </UncontrolledTooltip>
                            )}
                        </span>
                    )
                }}
            </PreferredDateTimeContext.Consumer>
        )
    }
}

const withCustomerTimezone = graphql(GetConfigurationSettings, {
    skip: (props) => !props.driverId,
    options: (props) => ({
        variables: { driverId: props.driverId, name: "PREFERRED_TIMEZONE" },
        fetchPolicy: "cache-first",
    }),
    props: ({ data: { getConfigurationSettings } }) => ({
        customerTimezone: getConfigurationSettings,
    }),
})

const withBranchTimezone = graphql(GetConfigurationSettings, {
    skip: (props) => !props.branchId || !!props.driverId,
    options: (props) => ({
        variables: { branchId: props.branchId, name: "PREFERRED_TIMEZONE" },
        fetchPolicy: "cache-first",
    }),
    props: ({ data: { getConfigurationSettings } }) => ({
        customerTimezone: getConfigurationSettings,
    }),
})

export default withBranchTimezone(withCustomerTimezone(DatetimeRenderer))
